import CONSTANTS from "./constants";
import BaseHttpHandler from "./utilities/baseHttpHandler";

// Gets all status codes
async function getAllStatusCodes() {
  try {
    let instance = await BaseHttpHandler.getInstance();

    const response = await instance.get(
      CONSTANTS.API_CONSTANTS.ENDPOINTS.CONTACT_CENTRE_STATUS_CODE,
      {
        cancelToken: BaseHttpHandler.getTimedCancelToken().token,
      }
    );

    return response.data;
  } catch (e) {
    // If the endpoint returns anything other a 200 response okay message we need to know about it and handle it appropriately
    console.log(e);
    throw e;
  }
}

export default {
  getAllStatusCodes,
};
